import { supabase } from '@/lib/supabase'

const KEY_REVIEW = 'ops.opportunities_review_enabled'

export async function getReviewEnabled(): Promise<boolean> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', KEY_REVIEW)
    .maybeSingle()
  if (error) throw error
  const v = (data?.value as string) || 'false'
  return v === 'true'
}

export async function setReviewEnabled(on: boolean): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEY_REVIEW, value: on ? 'true' : 'false' }, { onConflict: 'key' })
  if (error) throw error
}

